module.exports = __webpack_public_path__ + "static/recruit_home__reason-bgr-desktop-bda6fe31e9b85ea2de6af0faa41c1219.jpg";